import{GraphQLClient as n}from"graphql-request";const o=o=>{const{endpoint:r,config:t}=o;return new n(r,t)};export{o as createGraphQLClient};
